module.exports = __webpack_public_path__ + "742112e1a4b77788912955fe7c267819.svg";